import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'home-banner',
    name: 'app-content.home-banner',
    meta: {
      title: 'Home Banner',
      action: 'read',
      subject: CASL.ACCESS.BANNER
    },
    component: () => import('./list/HomeBannerListPage.vue')
  },
  {
    path: 'home-banner/:uuid/:order/add',
    name: 'app-content.home-banner.add',
    meta: {
      title: 'Home Banner Add',
      action: 'create',
      subject: CASL.ACCESS.BANNER
    },
    component: () => import('./form/HomeBannerFormPage.vue')
  },
  {
    path: 'home-banner/:uuid/:uuidContent/:order/edit',
    name: 'app-content.home-banner.edit',
    meta: {
      title: 'Home Banner Edit',
      action: 'update',
      subject: CASL.ACCESS.BANNER
    },
    component: () => import('./form/HomeBannerFormPage.vue')
  }
]
